/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { Description } from "@nordcloud/gnui";

const DescriptionWrap = styled.div`
  text-align: left;
`;

export function ValidationMessageVersion() {
  return (
    <DescriptionWrap>
      <Description>
        Please provide the correct value, in YYYY-MM format. The date cannot
        exceed 2099.
      </Description>
    </DescriptionWrap>
  );
}

const regex = /^20[1-9][0-9]-(0[1-9]|1[0-2])$/;

export const checkVersion = (value: string) => {
  if (value === "") {
    return true;
  }
  if (!value.match(regex)) {
    return "Please provide the correct value, in YYYY-MM format. The date cannot exceed 2099.";
  }

  return true;
};
